import React from 'react'
import Image from 'next/image'
import { useTranslation } from 'react-i18next'
import * as S from './SectionAppBioAtlas.styles'

const SectionAppBioAtlas = () => {
  const { t } = useTranslation()

  return (
    <S.Section>
      <S.Container className="mw-unsigned">
        <S.LeftCol>
          <S.Title>{t('landingV2.sectionAppBioAtlas.title')}</S.Title>
          <S.DownloadRow>
            <S.DownloadText>
              {t('landingV2.sectionAppBioAtlas.downloadText')}
            </S.DownloadText>
            <S.StoreLogos>
              <Image
                src={`${process.env.CDN_URL}/public/landingpagev2/images/apple-store-logo.png`}
                alt="Apple Store"
                width={40}
                height={40}
              />
              <Image
                src={`${process.env.CDN_URL}/public/landingpagev2/images/play-store-logo.png`}
                alt="Play Store"
                width={40}
                height={40}
              />
            </S.StoreLogos>
          </S.DownloadRow>
          <S.AppButton>{t('landingV2.sectionAppBioAtlas.button')}</S.AppButton>
        </S.LeftCol>
        <S.RightCol>
          <S.TabletImg>
            <Image
              src={`${process.env.CDN_URL}/public/landingpagev2/images/tablet.png`}
              alt="App BioAtlas no tablet"
              width={443}
              height={309}
            />
          </S.TabletImg>
        </S.RightCol>
      </S.Container>
      <S.PhoneImg>
        <Image
          src={`${process.env.CDN_URL}/public/landingpagev2/images/phone.png`}
          alt="App BioAtlas no celular"
          width={132}
          height={151}
        />
      </S.PhoneImg>
    </S.Section>
  )
}

export default SectionAppBioAtlas
